import { createAsyncThunk, createSlice,PayloadAction } from "@reduxjs/toolkit";
import { RootState } from '../../../app/store';
import fetchAPI from "../../../common/fetchAPI";
import { TaxCodeStateClass } from "./interfaces/taxcodeStateClass";
import { sortData } from "../../../common/timeLiveFunction";

const initialState: TaxCodeStateClass = {
    isLoading: false,
    status: 'idle',
    taxcodeList: [],
    selectedRecord: {},
    isReload: false,
    sortOrder: 'asc',
    sortColumn: 'TaxCode',
    search: '',
    pageNo: 1,
    pageSize: 10
}

interface IThunkApi {
    state: {
        taxcode: TaxCodeStateClass;
    },
}

export const getAccountTaxCodesAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        'taxcode/V2/getAccountTaxCodes',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/taxcodes', 'Get', '', true, '84abe7a4-6de7-48a9-b59f-9fc5f1a3958f');
            const json = await response.json();
            return json;
        }
    )

export const getAccountTaxCodeByAccountTaxCodeIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'taxcode/V2/getAccountTaxCodeByAccountTaxCodeId',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/taxcodes/' + arg, 'Get', '', true, '84abe7a4-6de7-48a9-b59f-9fc5f1a3958f');
            const json = await response.json();
            return json;
        }
    )

export const getAccountTaxCodeByAccountTaxZoneIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'taxcode/V2/getAccountTaxCodeByAccountTaxZoneId',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/taxcodes/GetAccountTaxCodeByAccountTaxZoneId/' + arg, 'Get', '', true, '84abe7a4-6de7-48a9-b59f-9fc5f1a3958f');
            const json = await response.json();
            return json;
        }
    )

export const addAccountTaxCodeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'taxcode/V2/addTaxCode',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/taxcodes/', 'POST', arg, true, '84abe7a4-6de7-48a9-b59f-9fc5f1a3958f');
            const json = await response.json();
            return json;
        }
    )

export const updateAccountTaxCodeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'taxcode/V2/updateAccountTaxCode',
        async (arg, thunkApi) => {
            const { AccountTaxCodeId, ...argWithoutId } = arg;
            const response = await fetchAPI('api/V2/taxcodes/' + AccountTaxCodeId, 'PUT', argWithoutId, true, '84abe7a4-6de7-48a9-b59f-9fc5f1a3958f');
            const json = await response.json();
            return json;
        }
    )

export const deleteAccountTaxCodeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'taxcode/V2/deleteAccountTaxCode',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/taxcodes/' + arg, 'DELETE', '', true, '84abe7a4-6de7-48a9-b59f-9fc5f1a3958f');
            const json = await response.json();
            return json;
        }
    )
export const DeleteSelectedAccountTaxCodeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "taxcode/v2/DeleteSelectedAccountTaxCode",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/taxcodes/DeleteSelected/', 'Delete', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;

        }
    )

export const taxcodeSlice = createSlice({
    name: 'taxcode',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        },
        checkedState: (state, action) => {
            const currentindex = state.taxcodeList.findIndex((item) => item.AccountTaxCodeId == action.payload);
            const newArray = [...state.taxcodeList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.taxcodeList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.taxcodeList.findIndex((item) => item.AccountTaxCodeId == action.payload);
            const newArray = [...state.taxcodeList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.taxcodeList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.taxcodeList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.taxcodeList = newArray;
        },
        unCheckedAllState: (state) => {
            const newArray = state.taxcodeList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.taxcodeList = newArray;
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.taxcodeList;
            state.taxcodeList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAccountTaxCodeByAccountTaxZoneIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(getAccountTaxCodeByAccountTaxZoneIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                if (Object.keys(payload.Data).length === 0) {
                    state.taxcodeList = [];
                } else {
                    state.taxcodeList = payload.Data;
                    state.taxcodeList.map((item: any) => {
                        item.isSelected = 0
                    });
                }
                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};
            })
            .addCase(getAccountTaxCodeByAccountTaxZoneIdAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(getAccountTaxCodeByAccountTaxCodeIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(getAccountTaxCodeByAccountTaxCodeIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                state.selectedRecord = payload.Data[0];
            })
            .addCase(getAccountTaxCodeByAccountTaxCodeIdAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })

            .addCase(addAccountTaxCodeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(addAccountTaxCodeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(addAccountTaxCodeAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(updateAccountTaxCodeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(updateAccountTaxCodeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(updateAccountTaxCodeAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(deleteAccountTaxCodeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(deleteAccountTaxCodeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(deleteAccountTaxCodeAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })

            .addCase(DeleteSelectedAccountTaxCodeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(DeleteSelectedAccountTaxCodeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(DeleteSelectedAccountTaxCodeAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })



    }
})

export const {
    resetSelectedRecordObjectInState, checkedAllState, unCheckedAllState, checkedState, unCheckedState,updatePagination,updateSorting
} = taxcodeSlice.actions
export const TaxCodeState = (state: RootState) => state.taxcode
export default taxcodeSlice.reducer